export class MediationFilters {
    publisherId: number;
    providerId: number;
    countryId: number;
    isLive: boolean;
}


// WEBPACK FOOTER //
// ./src/app/mediation/mediation.filters.ts